import React from 'react';
import { MapPin, Phone, Clock, MessageCircle, Mail, ExternalLink } from 'lucide-react';
import { SALON, whatsappLink, telLink } from '../data/content';

const Contact = () => {
  return (
    <div>
      {/* Hero */}
      <section className="bg-gradient-to-b from-gold-soft/40 to-cream py-20 md:py-28">
        <div className="max-w-5xl mx-auto px-5 md:px-8 text-center animate-fade-in-up">
          <span className="text-gold font-medium text-sm tracking-[0.25em] uppercase">Get in Touch</span>
          <h1 className="font-serif text-5xl md:text-6xl font-bold mt-4 text-neutral-900">
            Contact Information
          </h1>
          <div className="gold-divider mx-auto mt-6 mb-8" />
          <p className="text-lg text-neutral-600 leading-relaxed max-w-2xl mx-auto">
            We&apos;re here to help. Reach out to book an appointment or ask any questions.
          </p>
        </div>
      </section>

      {/* Contact cards + CTA */}
      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-6xl mx-auto px-5 md:px-8">
          <div className="grid md:grid-cols-3 gap-5 mb-12">
            <div className="bg-cream rounded-2xl p-7 border border-gold/15">
              <div className="w-12 h-12 rounded-full bg-gold flex items-center justify-center mb-4">
                <MapPin className="w-6 h-6 text-white" />
              </div>
              <h3 className="font-serif text-xl font-semibold text-neutral-900 mb-3">Our Location</h3>
              <p className="text-neutral-600 leading-relaxed">
                {SALON.addressLine1}<br />
                {SALON.addressLine2}<br />
                {SALON.addressLine3}
              </p>
              <a
                href={SALON.mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-flex items-center gap-1.5 text-sm text-gold font-medium hover:text-gold-dark btn-transition"
              >
                Open in Maps <ExternalLink className="w-3.5 h-3.5" />
              </a>
            </div>

            <div className="bg-cream rounded-2xl p-7 border border-gold/15">
              <div className="w-12 h-12 rounded-full bg-gold flex items-center justify-center mb-4">
                <Phone className="w-6 h-6 text-white" />
              </div>
              <h3 className="font-serif text-xl font-semibold text-neutral-900 mb-3">Phone Number</h3>
              <a
                href={telLink}
                className="text-neutral-700 hover:text-gold btn-transition text-lg font-medium"
              >
                {SALON.phone}
              </a>
              <p className="text-sm text-neutral-500 mt-2">
                Call us anytime during business hours
              </p>
            </div>

            <div className="bg-cream rounded-2xl p-7 border border-gold/15">
              <div className="w-12 h-12 rounded-full bg-gold flex items-center justify-center mb-4">
                <Clock className="w-6 h-6 text-white" />
              </div>
              <h3 className="font-serif text-xl font-semibold text-neutral-900 mb-3">Business Hours</h3>
              <p className="text-neutral-700 font-medium">{SALON.timingShort}</p>
              <p className="text-neutral-700">{SALON.timingHours}</p>
              <p className="text-sm text-neutral-500 mt-2">Walk-ins welcome</p>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-2xl mx-auto">
            <a
              href={telLink}
              className="flex-1 inline-flex items-center justify-center gap-2 px-7 py-4 bg-gold text-white rounded-full font-semibold shadow-lg hover:bg-gold-dark btn-transition hover:shadow-xl"
            >
              <Phone className="w-5 h-5" /> Call Now
            </a>
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="flex-1 inline-flex items-center justify-center gap-2 px-7 py-4 bg-whatsapp text-white rounded-full font-semibold shadow-lg hover:bg-whatsapp-dark btn-transition hover:shadow-xl"
            >
              <MessageCircle className="w-5 h-5 fill-white" /> Message on WhatsApp
            </a>
          </div>
        </div>
      </section>

      {/* Find Us Here */}
      <section className="py-16 md:py-20 bg-cream">
        <div className="max-w-6xl mx-auto px-5 md:px-8">
          <div className="text-center mb-10">
            <span className="text-gold font-medium text-sm tracking-[0.25em] uppercase">Visit Us</span>
            <h2 className="font-serif text-4xl md:text-5xl font-bold mt-3 mb-4 text-neutral-900">
              Find Us Here
            </h2>
            <div className="gold-divider mx-auto" />
          </div>

          <div className="rounded-2xl overflow-hidden shadow-lg border border-gold/20 bg-white">
            <iframe
              title="Headtouch Salon Location"
              src="https://maps.google.com/maps?q=Sushma%20Capital%20Dhakoli%20Zirakpur&t=&z=15&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="450"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
